import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { CourseManagement } from "../base/course-management";


export const CurricRequiredValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  return CourseManagement.isCurric(control.parent?.value) && !control.value ? { curricRequired: true } : null;
};


export const DaysPerWeekRangeValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  const daysPerWeek = parseInt(control.value);
  return daysPerWeek > 7 ? { daysPerWeekInvalidRange: true } : null;
};


export const DefaultAttendanceMinutesRangeValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  const defaultAttendanceMinutes = parseInt(control.value);
  return defaultAttendanceMinutes > 120 ? { defaultAttendanceMinutesInvalidRange: true } : null;
};


export const MaxNumberPrepDaysRangeValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  const maxNumberOfPrepDays = parseInt(control.value);
  return maxNumberOfPrepDays > 21 ? { maxNumberOfPrepDaysInvalidRange: true } : null;
};


